module.exports = __webpack_public_path__ + "static/media/speaker_DrDing.32dee61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_DrDing.jpg
// module id = 261
// module chunks = 0